import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout/Layout';
import backupService from '../../services/backupService';
import { FaDatabase, FaPlus, FaTrash, FaShieldAlt, FaDownload } from 'react-icons/fa';

export default function BackupPage() {
  const [backups,   setBackups]   = useState([]);
  const [cargando,  setCargando]  = useState(true);
  const [generando, setGenerando] = useState(false);
  const [mensaje,   setMensaje]   = useState(null);

  useEffect(() => { cargarBackups(); }, []);

  const cargarBackups = async () => {
    setCargando(true);
    try {
      const data = await backupService.listar();
      setBackups(data);
    } finally {
      setCargando(false);
    }
  };

  const handleCrear = async () => {
    setGenerando(true);
    setMensaje(null);
    try {
      const res = await backupService.crear();
      setMensaje({ tipo: 'success', texto: res.message });
      cargarBackups();
    } catch {
      setMensaje({ tipo: 'danger', texto: 'Error al generar el backup.' });
    } finally {
      setGenerando(false);
    }
  };

  const handleEliminar = async (nombre) => {
    if (!window.confirm('¿Eliminar este backup?')) return;
    try {
      await backupService.eliminar(nombre);
      setMensaje({ tipo: 'success', texto: 'Backup eliminado correctamente.' });
      cargarBackups();
    } catch {
      setMensaje({ tipo: 'danger', texto: 'Error al eliminar el backup.' });
    }
  };

  const handleDescargar = (nombre) => {
    const token = localStorage.getItem('token');
    window.open(
      `https://sistemafinanciero.digitaleseduproperu.com/api/backup/download?nombre=${nombre}&token=${token}`,
      '_blank'
    );
  };

  return (
    <Layout>
      {/* Encabezado */}
      <div className="page-header d-flex justify-content-between align-items-center">
        <div>
          <h4>Backup</h4>
          <p>Respaldo y restauración de la base de datos</p>
        </div>
        <button className="btn btn-danger" onClick={handleCrear} disabled={generando}>
          <FaPlus className="me-2" />
          {generando ? 'Generando...' : 'Crear Backup'}
        </button>
      </div>

      {/* Mensaje */}
      {mensaje && (
        <div className={`alert alert-${mensaje.tipo} alert-dismissible mb-3`}>
          {mensaje.texto}
          <button
            type="button"
            className="btn-close"
            onClick={() => setMensaje(null)}
          />
        </div>
      )}

      {/* Aviso de seguridad */}
      <div className="alert alert-warning d-flex align-items-center gap-2 mb-3">
        <FaShieldAlt />
        <small>
          Se recomienda realizar respaldos periódicos antes de actualizaciones mayores.
          
        </small>
      </div>

      {/* Lista de backups */}
      <div className="card card-custom">
        <div className="card-body">
          <h6 className="fw-bold mb-3">
            <FaDatabase className="me-2 text-primary-custom" />
            Backups Disponibles
          </h6>

          {cargando ? (
            <div className="text-center py-4">
              <div className="spinner-custom mx-auto" />
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-custom">
                <thead>
                  <tr>
                    <th>Archivo</th>
                    <th>Tamaño</th>
                    <th>Fecha Creación</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {backups.length > 0 ? (
                    backups.map((b) => (
                      <tr key={b.nombre}>
                        <td>
                          <FaDatabase className="me-2 text-muted" />
                          {b.nombre}
                        </td>
                        <td>{b.tamanio}</td>
                        <td>{b.fecha}</td>
                        <td>
                          <div className="d-flex gap-2">
                            <button
                              className="btn btn-sm btn-outline-primary"
                              onClick={() => handleDescargar(b.nombre)}
                              title="Descargar backup"
                            >
                              <FaDownload />
                            </button>
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleEliminar(b.nombre)}
                              title="Eliminar backup"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center text-muted py-4">
                        <FaDatabase size={32} className="mb-2 d-block mx-auto" />
                        Sin backups disponibles
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}